import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  name: 'Laura G.',
  detail: '37 años · Ciudad de México',
  text: 'Me dio mucha tranquilidad tener todo organizado. Cuando mi hijo tiene una molestia pequeña, ya sé dónde buscar primero en vez de quedarme dando vueltas en internet.'
}, {
  name: 'Marcela D.',
  detail: '55 años · Guadalajara',
  text: 'Es súper práctico. Me recordó muchas cosas que hacía mi abuela, pero ahora las tengo a la mano en el celular. Es de esos libros que terminas usando todas las semanas.'
}, {
  name: 'Patricia S.',
  detail: '49 años · Monterrey',
  text: 'Me encantó la organización. Buscas el síntoma y ahí tienes la solución. Ahorras muchísimo tiempo y te da confianza saber que estás usando algo natural y seguro.'
}, {
  name: 'Florencia B.',
  detail: '38 años · Puebla',
  text: 'Lo tengo en el celular y lo abro siempre. Las recetas para descansar mejor y las infusiones digestivas cambiaron la rutina de mi familia para bien.'
}, {
  name: 'Claudia F.',
  detail: '52 años · Querétaro',
  text: 'Está muy bien organizado por sistema y por síntoma. Encuentras rápido lo que buscas. Para mí eso era lo más importante: no perder tiempo leyendo cosas que no necesito.'
}, {
  name: 'Sofía E.',
  detail: '36 años · Mérida',
  text: 'La compré para tener alternativas más naturales en casa y superó mis expectativas. Tiene muchísimo contenido y los bonos extra son un complemento perfecto.'
}];
export function Testimonials() {
  return <section className="py-8 md:py-12 px-5 bg-cream-100 texture-paper" data-id="element-254">
      <div className="max-w-5xl mx-auto" data-id="element-255">
        <div className="text-center mb-8 md:mb-12 max-w-2xl mx-auto" data-id="element-256">
          <p className="text-xs uppercase tracking-[0.2em] text-olive-600 font-medium mb-4" data-id="element-257">
            Lo que dicen quienes la usan
          </p>
          <h2 className="font-serif font-medium text-3xl md:text-4xl text-ink-900 leading-tight" data-id="element-258">
            Miles de personas ya usan estos{' '}
            <span className="italic text-olive-600" data-id="element-259">remedios naturales</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-id="element-260">
          {testimonials.map((t, idx) => <div key={idx} className="bg-cream-50 border border-cream-300 rounded-2xl p-6 flex flex-col" data-id="element-261">
              <div className="flex gap-0.5 mb-4" data-id="element-262">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-olive-500 text-olive-500" data-id="element-263" />)}
              </div>
              <p className="font-serif text-base md:text-lg text-ink-800 leading-relaxed italic mb-5 flex-1" data-id="element-264">
                "{t.text}"
              </p>
              <div className="pt-4 border-t border-cream-300" data-id="element-265">
                <p className="font-medium text-ink-900 text-sm" data-id="element-266">{t.name}</p>
                <p className="text-xs text-ink-600" data-id="element-267">{t.detail}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}